module.exports = __webpack_public_path__ + "static/media/Rectangle 9 (3).a963c08c.png";